<template>
  <Layout
  :isForm="true"
  :hideHeader="formInfo.header_type == 1"
  :hideFooter="formInfo.footer_type == 1"
  :info="formInfo"
  :loginType="loginType"
  >
    <template slot="logo" v-if="formInfo && formInfo.header_type === 2">
      <a href="javascript:void(0);" slot="logo">
        <img :src="formInfo.header_content" alt="logo" />
      </a>
    </template>
    <div slot="header"></div>
    <div slot="nav"></div>
    <div slot="wap-next"></div>
    <div slot="sub-nav"></div>

    <div class="blur-bg"
    :class="{'mobile-blur-bg': isMobile}"
    :style="{'background': `url(${isMobile ? formInfo.banner_mb : formInfo.banner}) no-repeat center top/cover`}">
    </div>
    <div class="layout-content">
      <div class="form-banner">
        <img v-if="!isMobile && formInfo.banner" :src="formInfo.banner" alt="">
        <img v-if="isMobile && formInfo.banner_mb" :src="formInfo.banner_mb" alt="">
      </div>
      <div class="form-main">
        <div class="form-title">{{formInfo.title}}</div>
        <div class="introduction">
          <RichContent :content="formInfo.desc || ''"/>
        </div>
        <div v-if="loginType && !loginUser" class="need-login">* 此表单需要登录后填写，<span @click="login">立即登录</span></div>
        <div class="position-anchor" ref="positionAnchor"></div>
        <div class="questions" v-if="formStatus === 1">
          <div v-if="isMobile && loginType && !loginUser" class="login-mask" @click="login"></div>
          <FormQuestion
            :data="currentPageInfo"
            :currentPage="currentPage"
            :maxPage="maxPage"
            :answersWriting="answersWriting"
            :formId="formId"
            :protocols="protocols"
            :userFieldInfo="userFieldInfo"
            @updateProtocols="updateProtocols"
            @changePage="changePage"
            @judgeRule="judgeRule"
          />
        </div>
        <template v-if="formStatus !== 1">
          <div ref="submitStatusPoint">
            <div class="expired" :class="{success: formStatus === 3}">
              <span>{{formStatusTips}}</span>
            </div>
            <FormSuccess v-if="formStatus === 3 && windowInfo" :windowInfo="windowInfo" />
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VueScrollTo from 'vue-scrollto'
import utils from '../../utils'
import ServerEvent from '../../service/event.service'
import SensorsReporter from '../../utils/sensors.report'

import config from '../../config'

import Layout from '../../components/layout/Layout'
import RichContent from '../../components/event/RichContent'
import FormQuestion from './FormQuestion'
import FormSuccess from './FormSuccess'

export default {
  name: 'form-self',
  components: {
    Layout,
    RichContent,
    FormQuestion,
    FormSuccess
  },
  data () {
    return {
      formId: this.$route.query.id,
      previewUrl: this.$route.query.previewurl,
      loginType: 0,
      sign: window.location.search.indexOf('?') > -1 ? window.location.search.slice(1) : window.location.search,
      // 0 未开始 1 进行中 2 已结束 3 提交成功
      formStatus: 1,
      enterTime: '',
      // 表单数据 - 全
      formInfo: {},
      // 表单协议
      protocols: [],
      // 试题列表
      allQuestionInfo: [],
      // 当前最大页码：点击下一页进到
      maxPage: 0,
      // 当前页
      currentPage: 0,
      // 当前页题目信息
      currentPageInfo: [],
      // 节点题 题号
      handleNode: [],
      // 分页数据
      question_page: [],
      // 题目规则
      rules: {},
      unnecessaryId: [],
      // 将规则中涉及到的需要隐藏的题进行筛选
      hideQuestions: [],
      pageNumberLists: [],
      answersWriting: [],
      // submit成功后返回信息
      windowInfo: {},
      userFieldInfo: {}
    }
  },
  computed: {
    ...mapState(['isMobile', 'nowTime', 'loginUser', 'pageAction', 'loginDomain']),
    platform () {
      return this.isMobile ? 'mobile' : 'pc'
    },
    formStatusTips () {
      switch (this.formStatus) {
        case 0:
          window.onbeforeunload = null
          return '表单未开始收集'
        case 1:
          return '表单收集中'
        case 2:
          window.onbeforeunload = null
          return '表单已结束收集'
        default:
          window.onbeforeunload = null
          return '表单提交成功'
      }
    },

    isGeekTimeNPSGroupId () {
      return this.formInfo.group_id === 104
    }
  },
  watch: {
    // 用户登录后获取账户中心数据，回显用户信息组件
    loginUser: {
      handler (newVal, oldVal) {
        if (this.loginDomain === 'biz') {
          return
        }

        if (newVal !== oldVal && newVal?.uid) {
          this.getUserFieldInfo()
        }
      }
    },
    pageAction (val) {
      this.changeSuccessState(this.formInfo, val)
    }
  },
  created () {
    if (!utils.isInApp()) {
      window.onbeforeunload = function (e) {
        let msg = '确定离开么？'
        return msg
      }
    }

    // hack 运营配置错链接并已印刷，这里做下重定向
    if (window.location.href === 'https://www.infoq.cn/form/?previewurl=https%3A%2F%2Fstatic001.infoq.cn%2Fresource%2Fform%2Fpreview%2Fformpreview.json') {
      window.location.href = 'https://www.infoq.cn/form/?id=1870'
    }

    if (this.previewUrl) {
      ServerEvent.getPrivewInfo(this.previewUrl).then(res => {
        this.previewPage(res)
      })
    } else {
      let param = {id: Number(this.formId)}
      ServerEvent.getFormInfo(param).then(formInfo => {
        this.formInfo = formInfo
        this.protocols = this.getProtocols(formInfo)
        this.loginType = formInfo.login_type

        const loginDomainMap = {
          '1': 'time',
          '2': 'infoq',
          '3': 'biz'
        }
        let loginDomain = loginDomainMap[formInfo.login_domain] || 'infoq'
        this.$store.commit('SET_LOGIN_DOMAIN', loginDomain)
        // if (this.loginType) this.getSigninInfo()

        if (loginDomain !== 'biz') {
          this.getUserFieldInfo()
        }

        this.formStatus = this.nowTime > this.formInfo.end_time * 1000
        ? 2 : this.nowTime < this.formInfo.start_time * 1000
        ? 0 : 1

        // 微信分享
        document.title = `${formInfo.title}`
        let opt = this.InitShareMsg(this.formInfo.share_content)
        utils.shareWeixin(opt)

        // 活动进行中
        if (this.formStatus === 1) {
          ServerEvent.getFormQuestion(param).then(questionInfo => {
            this.init(questionInfo)
          }).catch(err => {
            console.log(err)
            this.$router.push('/404')
          })
        }
      }).catch(err => {
        console.log(err)
        this.$router.push('/404')
      })
    }
  },
  mounted () {
    this.getPageAction((options) => {
      if (options.type === 'doSubmitService') {
        window.scrollTo(0, 110)
        this.formStatus = 3
        this.windowInfo = null
      }
    })
  },
  methods: {
    ...mapActions(['getSigninInfo', 'getPageAction']),
    // 登录
    login () {
      this.$Message.toast({
        message: '登录后才可提交表单'
      })
      utils.login()
    },
    // 页面初始化
    init (questionInfo) {
      // 给每个题添加显示标记
      questionInfo.list.forEach(item => {
        if (typeof item.details !== 'object') {
          item.details = JSON.parse(item.details)
        }
        // item.details = JSON.parse(item.details)
        item.showQuestion = 0
      })

      this.allQuestionInfo = questionInfo.list
      this.question_page = questionInfo.question_page || []
      // this.maxPage = this.question_page.length - 1
      this.rules = questionInfo.relations || {}
      this.hideQuestions = this.getHideQuestionsLists(this.rules)
      this.unnecessaryId = [...this.hideQuestions]
      // pageNumberLists 是把每页的题目 打上显示或隐藏标记
      this.pageNumberLists = this.getShowQuestionLists(this.question_page, this.hideQuestions)
      this.currentPageInfo = this.getCurrentPageInfo({currentPage: this.currentPage})
      this.getMaxPageNumber()
    },

    /**
     * 整理 protocol 隐私协议数据
     */
    getProtocols (formInfo) {
      let protocols = []

      const setProtocol = (key) => {
        if (formInfo && formInfo[key]) {
          const protocol = formInfo[key]
          if (protocol) {
            try {
              let pro = JSON.parse(protocol)
              if (pro.required) {
                pro.isAgree = false
                protocols.push(pro)
              }
            } catch (err) {
              console.log(err)
            }
          }
        }
      }

      setProtocol('protocol')
      setProtocol('protocol2')

      return protocols
    },

    updateProtocols ({ index, val }) {
      this.$set(this.protocols[index], 'isAgree', val)
    },

    /**
     * 获取当前页题目信息
     * @param {Number} page
     */
    getCurrentPageInfo ({
      currentPage,
      pageNumberLists = this.pageNumberLists,
      allQuestionInfo = this.allQuestionInfo,
      type = 'next'
    }) {
      let qids = []
      pageNumberLists[currentPage].forEach(itemPage => {
        if (itemPage.isShow === true) {
          qids.push(itemPage.qid)
        }
      })

      allQuestionInfo.forEach(itemQuestion => {
        itemQuestion.showQuestion = 0
        if (qids.includes(itemQuestion.id)) {
          itemQuestion.showQuestion = 1
        }
      })

      return allQuestionInfo
    },
    getUserFieldInfo () {
      return ServerEvent.getEnterpriseUserFieldsValue().then(data => {
        this.userFieldInfo = data
        return data
      })
    },

    // 根据规则，筛选出节点控制的需要隐藏的题目
    // {2:{a:[],b:[]}, 3:{a:[],b:[]}}
    getHideQuestionsLists (rules) {
      let hideQuestions = []
      Object.keys(rules).forEach(key => {
        if (rules[key]) {
          this.handleNode.push(Number(key))
          Object.keys(rules[key]).forEach(pageArr => {
            hideQuestions.push(...rules[key][pageArr])
          })
        }
      })
      return hideQuestions
    },

    // 分页数据 + 需要隐藏的题目 => 标记题目的显示状态（初始题目的显示）
    // [[1,2,3],[4,5,6],[7,8,9]]
    getShowQuestionLists (questions, hideQuestions) {
      questions.forEach((items, i, arr) => {
        items.forEach((item, j) => {
          // 添加 isshow 标记当前题目的显示状态
          arr[i][j] = {
            qid: item,
            isShow: true
          }
          if (hideQuestions.includes(item)) {
            arr[i][j].isShow = false
          }
        })
      })
      return questions
    },

    // 切换页码 && 提交
    changePage ({type, answers, clear}) {
      if (type === 'prev' && this.currentPage > 0) {
        this.currentPage--
        this.getCurrentPageInfo({currentPage: this.currentPage, type: 'prev'})
        // window.scrollTo(0, 110)
        clear && clear()
        this.goAnchor()
      } else {
        if (type === 'next' && this.currentPage < this.pageNumberLists.length - 1) {
          this.currentPage++
          this.getCurrentPageInfo({currentPage: this.currentPage, type: 'next'})
          // window.scrollTo(0, 110)
          clear && clear()
          this.goAnchor()
        } else {
          // 提交表单
          let postData = this.filterAnswer(answers)

          // // 校验答案是否为空
          if (postData.length === 0) {
            this.$Message.toast({ message: '必填题目不能为空呦~' })
            clear && clear()
            return
          }

          let submitInfo = {
            id: this.formInfo.id,
            answers: postData,
            start_time: this.nowTime,
            sign: this.sign
          }

          this.doSubmitService(submitInfo, clear)
        }
      }
    },

    doSubmitService (submitInfo, unLock) {
      ServerEvent.submitForm(submitInfo, {type: 'doSubmitService', needLogin: this.loginType}).then(res => {
        unLock && unLock()

        // 处理神策上报事件，此处只给 NPS 分组做数据上报
        if (this.isGeekTimeNPSGroupId) {
          SensorsReporter.pushSubmitSuccess({
            group_name: this.formInfo.group_name || '轻课NPS表单',
            form_id: this.$route.query.id,
            form_title: this.formInfo.title
          })
        }

        this.changeSuccessState(submitInfo, res)

        // 如果在小程序内返回上一页
        if (utils.isInWXMiniProgram()) {
          setTimeout(() => { utils.mpNavigateBack() }, 2000)
        } else {
          let redirect = this.$route.query.redirect || ''
          if (redirect) setTimeout(() => { window.location.href = decodeURIComponent(redirect) }, 2000)
        }
      }).catch((err) => {
        // if (!this.loginUser) {
        //   this.$Message.toast({
        //     message: '登录后才可提交表单'
        //   })
        // } else {
        //   this.$Message.toast({
        //     message: '😭提交失败，请稍后再试'
        //   })
        // }
        unLock && unLock()
        this.$Message.toast({
          message: err.msg || '😭提交失败，请稍后再试'
        })
      })
    },
    /**
     * 定位到每页的第一题或者  提交成功的位置
     */
    goAnchor () {
      this.$nextTick(() => {
        VueScrollTo.scrollTo(this.$refs.positionAnchor, {
          duration: 0
        })
      })
    },
    changeSuccessState (submitInfo, info) {
      utils.storage.remove('tel')

      if (info.id.length < 1) {
        // 提交成功
        window.ga && window.ga('send', 'event', `表单提交按钮点击数`, `${submitInfo.id} - ${this.platform}`, '表单通过')
        this.formStatus = 3
        this.windowInfo = info.window
        window.onbeforeunload = null
        this.goAnchor()
      } else {
        this.$Message.toast({
          message: '当前表单有更新，请刷新后重新填写~',
          duration: 0,
          closable: true
        })
      }
    },
    // 点击节点题目时筛选需要显示/隐藏的题型
    // TODO 规则题目包含了另一个规则题目时，题目显示异常
    judgeRule (qInfo) {
      let {qId, qKey} = qInfo
      let showIds = []
      let hideIds = []
      Object.keys(this.rules).forEach(key => {
        if (Number(qId) === Number(key)) {
          Object.keys(this.rules[key]).forEach(idArr => {
            if (qKey === idArr) {
              showIds = this.rules[key][idArr]
            } else {
              hideIds.push(...this.rules[key][idArr])
            }
          })
        }
      })
      this.pageNumberLists.forEach(pageItem => {
        pageItem.forEach(questionItem => {
          if (hideIds.includes(questionItem.qid)) {
            questionItem.isShow = false
            questionItem.necessary = false
          }
          if (showIds.includes(questionItem.qid)) {
            questionItem.isShow = true
            questionItem.necessary = true
          }
        })
      })
      // 这里非必要的题目id需要 跟showIds 取差集，有时候 题目显示规则里 会有相同的隐藏题
      // 比如  第一题 选A  出现  2345 题， 选B 出现 2367题，这时候 hideIds 里会一直有23题，导致最后过滤答案时候  用unnercessaryId 验证是不是隐藏的题会出错
      this.unnecessaryId = hideIds.filter(id => !showIds.includes(id))
      this.getMaxPageNumber()
      this.getCurrentPageInfo({currentPage: this.currentPage, type: 'node'})
    },

    filterAnswer (info) {
      // 提交表单
      let formData = info
      let postData = []
      for (let key in formData) {
        // nps 题目数据是  0 - 10， 选择0 的话 命中 !formData[key]
        // 所以改成 formData[key] === ''
        if (formData[key] === '' || formData[key].length < 1) {
          continue
        }

        let result = {question_id: null, type: null, options: []}

        // 填空题的 key 是用 - 把 题目id 和 key 连接起来的
        let arr = key.split('-')
        // arr.length === 3 -> id - key - type ex: 打分
        if (arr.length === 3) {
          result.question_id = Number(arr[0])
          result.type = Number(arr[2])
          result.options.push({
            key: arr[1],
            value: String(formData[key])
          })
          // arr.length === 2 -> id - type ex: 地址
        } else if (arr.length === 2) {
          result.question_id = Number(arr[0])
          result.type = Number(arr[1])
          result.options = [...formData[key]]
        } else {
          result.question_id = Number(arr[0])
          // 值是字符串 -> 单选题
          if (typeof formData[key] === 'string') {
            let arr = formData[key].split(config.dataConcatStr)
            result.type = Number(arr[2])
            result.options.push({
              key: arr[0],
              value: String(arr[1])
            })
          } else if (Array.isArray(formData[key]) && typeof formData[key][0] === 'string') {
            // 多选题
            formData[key].forEach(item => {
              let arr = item.split(config.dataConcatStr)
              result.type = Number(arr[2])
              result.options.push({
                key: arr[0],
                value: String(arr[1])
              })
            })
          } else {
            // 下拉框
            if (formData[key].length > 1) {
              result.type = 100800
              result.options = [...formData[key]]
            } else {
              result.type = 100400
              result.options = [...formData[key]]
            }
          }
        }
        // 规则包含但是隐藏着的题目答案不在收集范围
        if (result.question_id && !this.unnecessaryId.includes(result.question_id)) {
          postData.push(result)
        }
      }
      return postData
    },

    getMaxPageNumber () {
      let pageList = this.pageNumberLists
      let maxPage = 0
      pageList.forEach(item => {
        for (let index = 0; index < item.length; index++) {
          if (item[index].isShow === true) {
            maxPage++
            break
          }
        }
      })
      this.maxPage = maxPage - 1
    },

    InitShareMsg (info) {
      let shareInfo = null
      if (typeof info === 'string') {
        shareInfo = JSON.parse(info)
      } else {
        shareInfo = {}
      }
      let reg = /<[^>]+>/g
      const { desc = '' } = this.formInfo
      const shareDesc = desc.replace(reg, '')
      return {
        title: shareInfo.title || this.formInfo.title,
        desc: shareInfo.desc || shareDesc,
        imgUrl: shareInfo.logo || ''
      }
    },

    previewPage (data) {
      console.log('message form===> ', data)
      if (data) {
        let relationsObj = {}
        data.relations.forEach((item, i) => {
          relationsObj[item.question_id] = {}
          item.relations.forEach((option, j) => {
            relationsObj[item.question_id][option.option_key] = [...option.question_ids]
          })
        })

        let questionInfo = {
          list: data.list,
          relations: relationsObj,
          question_page: data.question_page
        }

        this.formInfo = data.info
        this.init(questionInfo)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

img {
  width: 100%;
  display: block;
}

.blur-bg {
  position: absolute; z-index: 0;
  top: 0;left: 0;
  width: 100%; height: 600px;
  opacity: .8;
  filter: blur(12px);
}

.blur-bg::after {
  content: '';
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  background-image: linear-gradient(to top, rgba(241, 242, 244, 1) 15%, rgba(255,255,255,0));
}

.layout-content {
  position: relative;
  margin-top: 40px;
  margin-bottom: 50px;
  width: 800px;
  background: #fff;
  box-shadow: 0px 4px 6px 0px rgba(94, 102, 124, 0.1);
  border-radius: 3px;
  // overflow: hidden;
  // z-index: 2;

  & .form-main {
    padding: 38px 60px 50px;

    & .expired {
      position: relative;
      padding: 50px 0 25px;
      width: 100%;
      text-align: center;
      &::before {
        content: '';
        position: absolute; top: 0; left: 0;
        height: 0px; width: 100%;
        border-top: 1px dashed $grayForm;
      }
      // border-bottom: 1px dashed $grayForm;
      // transform: translate(-3.7%);

      & span {
        position: relative;
        display: inline-block;
        height: 24px;
        font-size: 24px; line-height: 1; font-weight: bold;
        color: #828A92;

        &::after,
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          width: 34%; height: 1px;
          background: #828A92;
          opacity: 1;
        }

        &::before {
          left: -40%;
        }

        &::after {
          left: 108%;
        }
      }

      &.success {
        & span {
          color: #1458d4;
          &::after,
          &::before {
            background: #1458d4;
          }
        }
      }
    }

    & .submit-success-tip {
      position: relative;
      padding: 10px 0 40px;
      margin-bottom: 30px;
      width: 108%;
      text-align: center; font-size: 24px; color: #828A92;
      border-bottom: 1px dashed $grayForm;
      transform: translate(-3.7%);
      & span {
        display: block;
      }
    }

    & .form-title {
      margin-bottom: 25px;
      text-align: center;
      color: $lightBlack;
      line-height: 1.3;
      @include font(20, 600);
    }

    & .introduction {
      margin-bottom: 20px;
      line-height: 24px;
      color: $bodyBlack;
      @include font(16, 400);
    }

    & .need-login {
      padding: 0 0 20px;
      color: $bodyBlack;
      & span {
        cursor: pointer;
        color: $blue;
      }
    }
    & .questions {
      position: relative;
      & .login-mask {
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0; z-index: 999;
        background: transparent;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  ::v-deep .inner-content {
    padding-top: 0;
  }
  .mobile-blur-bg {
    position: relative;
    height: 38vw;
    filter: blur(3px);

    &::after {
      background-image: none;
    }
  }

  .layout-content {
    z-index: 1;
    margin-top: 0;
    padding-top: 0;
    width: calc(100vw - 20px);
    overflow: initial;

    & .form-banner {
      margin: -130px auto 0;
      width: calc(100vw - 20px);
      border-radius: 5px;
      overflow: hidden;

      & img {
        display: block;
        // height: 169px;
        background-color: #dfdfdf;
      }
    }

    & .form-main {
      margin: 0 auto;
      padding: 30px 20px;
      width: calc(100vw - 20px);
      box-shadow: 0px 2px 7px 0px rgba(94, 102, 124, 0.1);

      & .expired {
        width: 100%;
      }
    }
  }
}
</style>
